import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/olympic-peninsula-loop';
import MapSection from '../components/Maps/olympic-peninsula-loop';

class OlympicPeninsulaLoop extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Olympic Peninsula Loop: 3-Day Pacific Northwest Road Trip</title>
          <meta name="description" content="Plan a 3-day Olympic Peninsula loop from Seattle. Rain forest, glaciers, ocean beaches, and mountain views — the most diverse landscape drive in the Pacific Northwest." />
          <meta property="og:title" content="Olympic Peninsula Loop: 3-Day Pacific Northwest Road Trip" />
          <meta property="og:description" content="Plan a 3-day Olympic Peninsula loop from Seattle. Rain forest, glaciers, ocean beaches, and mountain views — the most diverse landscape drive in the Pacific Northwest." />
          <meta property="og:url" content="https://exploroff.com/itineraries/olympic-peninsula-loop" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/olympic-peninsula/olympic-peninsula.jpg" />
          <link rel="canonical" href="https://exploroff.com/itineraries/olympic-peninsula-loop" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Olympic Peninsula Loop: 3-Day Pacific Northwest Road Trip",
            description: "Plan a 3-day Olympic Peninsula loop from Seattle — rain forest, glaciers, ocean beaches, and mountain views.",
            image: ["https://exploroff.com/img/olympic-peninsula/olympic-peninsula.jpg"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/olympic-peninsula-loop" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Olympic Peninsula Loop: 3-Day Road Trip"
          category="itineraries"
          slug="olympic-peninsula-loop"
          excerpt="Rain forest, glaciers, ocean beaches, and mountain views in one epic 3-day loop from Seattle."
          tags={['road trip', 'pacific northwest', 'hiking']}
          readTime={9}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Kalaloch Lodge', type: 'NPS Lodge · Kalaloch Beach', url: 'https://www.booking.com/searchresults.html?ss=Kalaloch%2C+Washington' },
            { name: 'Lake Crescent Lodge', type: 'NPS Lodge · Lake Crescent', url: 'https://www.booking.com/searchresults.html?ss=Port+Angeles%2C+Washington' },
            { name: 'Hotels in Port Angeles', type: 'Gateway City · Olympic NP', url: 'https://www.booking.com/searchresults.html?ss=Port+Angeles%2C+Washington' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default OlympicPeninsulaLoop;
